<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Expense Category</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>

				<v-flex xs12 sm12 md12 form-item>
	               <v-text-field  v-model="Form.name" label="Name" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
	            </v-flex>


		        <v-flex xs12 sm12 md12 form-item @click="fn_openAccountLedgers('android', 'AccountGroups', 'field_accountLedger', Form.accountLedgerId, Form.accountLedgerName)">

	               <v-text-field  
	               		readonly 
	               		v-model="Form.accountLedgerName" 
	               		label="Ledger" 
	               		placeholder=" "
	               		append-icon="arrow_drop_down"
	               		ref="field_accountLedger" 
		               	:onUpdate="fn_updateAccountLedger" 
		               	v-validate="'required'" 
		               	data-vv-name="ledger"
		               	:error-messages="errors.collect('ledger')" 
		               	required>
	               	</v-text-field>
	            </v-flex>

			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
			
				
		</v-form>

	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
		<dialog-parties ref="ref_dialogLedger" :newParty="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-parties>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;

import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogParties from '../../../dialogs/dialog_parties'

import {draftMixin} from '../../../draft_mixin'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"expenseCategoryId":null, "name":null, "accountLedgerId":null, "accountLedgerName":null, "isSystem":0},
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,
				backButtonPress: false,
				snackbar:false,
				snackbar_msg:null,
				unwatch:false,
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		components:{
			'dialog-discard': dialogDiscard,
			'dialog-parties':dialogParties
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			// fn_openAccountLedgers: function (platform, name, ref, itemId, itemName) {

			// 	let viewDialogObject = { ToolbarTitle:"Ledger", groupTypeId:null, action:"new", accountGroups:null, accountGstTypes:null };
			// 	viewDialogObject.ToolbarTitle = "Ledger";
			// 	viewDialogObject.selectedItem = null;
			// 	viewDialogObject.ref = ref;
			// 	viewDialogObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];
			// 	viewDialogObject.selectedItem = {"itemId":itemId, "itemName":itemName};

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.$nextTick(() => {
			// 		this.fn_openDialogWeb('web', 'Ledger', 'ref_dialogLedger');
			// 	})
			// },

			fn_openAccountLedgers: function (platform, name, ref, itemId, itemName) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"new"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;

				viewDialogObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];
				// if(ref=='ref_expenseLedger'){
				// 	viewDialogObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];
				// }

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountLedgerId = selectedValueId;
		        	this.Form.accountLedgerName = selectedValueName;
		        	this.fn_validateExpenseLedger();
		        	this.errors.remove('');
				}
				else{
					this.Form.accountLedgerId = null;
		        	this.Form.accountLedgerName = null;
				}
				this.$forceUpdate();
			},

			fn_validateExpenseLedger: function (partyGroups) {
				let filterObject = {};
				let partyId = this.Form.accountLedgerId;
				filterObject.accountGroups = [accountGroupIds.indirectExpense.id, accountGroupIds.directExpense.id, accountGroupIds.fixedAssets.id];

				let self = this;
				this.getFilterData('ValidateParty', partyId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let isPartyValid = JSON.parse(response);
							if(!isPartyValid){
								self.Form.accountLedgerId = null;
								self.Form.accountLedgerName = null;
								self.showToast("Invalid Expense Ledger");
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('ExpenseCategory', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	self.showToast('Already exists with this name');
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = 'expenseCategory';
					data.id = this.Form.expenseCategoryId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.$router.go(-1);
				});
			},

			fn_post: function(){
				if(!this.Form.expenseCategoryId){
					this.Form.expenseCategoryId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}
				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				this.Form.name = this.Form.name.trim();
				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData, bindData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false;
				this.getData('ExpenseCategory', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							
					        var item = JSON.parse(response);

					        if(bindData){
					        	self.fn_bindData(item, copyData);
					        }
					        
					        
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function(item, copyData){
				this.unwatch = true;
				this.Form.name = item.name;
		        this.Form.expenseCategoryId = item.expenseCategoryId;
		        this.Form.accountLedgerId = item.accountLedgerId;
		        this.Form.accountLedgerName = item.accountLedgerName;
		        this.Form.isSystem = item.isSystem;

		        if(copyData){
		          	this.Form.expenseCategoryId=null;
		          	this.Form.isSystem = 0;
					this.showToast("Expense Category copied");
		        }

		        this.$root.fn_copyFormObject(this.Form, this.formId);
			},

			fn_clearForm: function(){
				this.Form = {"expenseCategoryId":null, "name":null, "accountLedgerId":null, "accountLedgerName":null, "isSystem":0};
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.fn_saveDraft(this.Form.name);
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId:103, ls:1}})
				}
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Expense Category";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "ledger":
					    	this.fn_updateAccountLedger(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},

		},
		mounted: function(){
			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('expensecategoryforms')){
				formsArray = JSON.parse(localStorage.getItem('expensecategoryforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('expensecategoryforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);
					}

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', 'Account Groups');

		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(from.name=='expenseCategoryItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'expenseCategoryItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'expenseCategoryDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		if(itemId){
	  				vm.fn_get(itemId, copyData, true);
	  			}

		  	})
		},
		beforeRouteUpdate (to, from, next) {
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('accountgroupsforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{

				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('accountgroupsforms', function(){
						next();
					})
				}
				
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/expense_categories/form.vue